import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initEmbed } from './utils/embed'

// Capture ?embed=1 from the entry URL before first paint so embed mode persists the whole visit.
initEmbed()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
